import _ from "lodash";
import { useCallback, useState } from "react";
import { getNextSortDirection, SortDirection } from "./SortDirection";
import { RideHeaderColumn } from "../../lib/types/types";

interface SortField {
  name: string;
  direction: SortDirection;
}

export const useSimpleSortBehaviour = <T extends any>(data: T[]) => {
  const [sortedData, setSortedData] = useState([...data]);
  const [sortField, setSortField] = useState<SortField | null>(null);

  const sortCallback = useCallback(
    (column: RideHeaderColumn) => {
      const name = column.name;

      let direction: SortDirection | undefined;
      if (name !== sortField?.name) {
        direction = SortDirection.ASCENDING;
      } else {
        direction = getNextSortDirection(sortField?.direction);
      }

      let sortedData = data;
      if (direction !== SortDirection.INACTIVE) {
        sortedData = _.sortBy(data, [column.name]);
      }
      if (direction === SortDirection.DESCENDING) {
        sortedData = sortedData.reverse();
      }

      setSortedData(sortedData);
      setSortField({ name, direction });
    },
    [data, sortField, setSortField, setSortedData]
  );

  return { sortedData, sortCallback };
};
